import CircularProgress from '@mui/material/CircularProgress';
import { useEffect, useState, useContext } from "react";
import getAllRecruitmentPartnersAndClients from "../../apis/getAllRecruitmentPartnersAndClients";
import "./AdminReferral.css";
import AdminReferralKendo from "./AdminReferralKendo";
import { UserTypeContext } from "../../AppRoute";
import getSkills from "../../apis/Tests/getSkills";
import { useNavigate } from "react-router-dom";
import getReferralPartnerSkills from "../../apis/adminReferralAPI/getReferralPartnerSkills";
import { DateTime } from "luxon";
import Tooltip from '@mui/material/Tooltip';
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import UnauthorizedAccess from '../../components/UnauthorizedAccess/UnauthorizedAccess';
const AdminReferral = ({ idContextTest }) => {
  const { userType, userIdType } = useContext(UserTypeContext);
  const [isDataLoaded, setisDataLoaded] = useState(false);
  const [allPublicSkill, setallPublicSkill] = useState([]);
  const [allRecruitmentOrgs, setAllRecruitmentOrgs] = useState([]);
  const [allData, setAllData] = useState([]);
  const history = useNavigate();

  const getAllSkills = async () => {

    let allSkillResponse = await getSkills();

    setallPublicSkill(
      allSkillResponse.data.data.filter((i) => i.isActive === true)
    );

  };
  const getRecruitmentOrgs = async () => {

    let allData = await getAllRecruitmentPartnersAndClients();
    let data = allData.data.data;
    let newData = [];
    for (let i = 0; i < data.length; i++) {
      if (data[i].isActive === true) {
        newData.push(data[i]);
      }
    }

    setAllRecruitmentOrgs(newData);

  };

  const goToDashboard = () => {
    history("/admin-home");
  }

  const getData = async () => {

    let data = await getReferralPartnerSkills();
    let allDataSet = data.data.data;
    for (let i = 0; i < allDataSet.length; i++) {
      // skill filter for duplicate values
      let skills = allDataSet[i].referralskills.map(
        (item) => item?.skill?.name
      );

      skills = skills.filter((item, index) => skills.indexOf(item) === index);
      skills = skills.filter(Boolean).join(", ");
      allDataSet[i].skills = skills;

      // location filter for duplicate values
      let locations = allDataSet[i].referralskills.map(
        (item) => JSON.parse(item.location).name
      );

      locations = locations.filter(
        (item, index) => locations.indexOf(item) === index
      );
      locations = locations.filter(Boolean).join(", ");
      allDataSet[i].locations = locations;

      //dates
      const date = allDataSet[i].createdAt;
      const formatted = DateTime.fromISO(date)
        .toLocal()
        .startOf("day")
        .toJSDate();
      allDataSet[i].formattedDate = formatted;
    }

    setAllData(allDataSet);

  };

  useEffect(() => {
    const fetchAllData = async () => {
      try {
        await getData();
        await getRecruitmentOrgs();
        await getAllSkills();
      } catch (error) {
        setisDataLoaded(true);
      } finally {
        setisDataLoaded(true);
      }
    }
    fetchAllData();

  }, []);

  return (
    <>
      
          <div className="main_container_adminReferral">
            {!isDataLoaded ? (
              <div className="row padding_80 text-center">
                <CircularProgress />
              </div>
            ) : (
              <>
                {userType === "Admin" ? (
                  <>
                    <div className="communityHeader_adminReferral">
                      <div className="goBackButton" onClick={(e) => goToDashboard()}>
                        <Tooltip title="Go Back to Dashboard" placement="bottom">
                          <ArrowBackIcon sx={{ fontSize: 20 }} />
                        </Tooltip>
                      </div>
                      <div className="communityTitle">Referral</div>
                    </div>
                    <AdminReferralKendo userType={userType} userIdType={userIdType} isDataLoaded={isDataLoaded} setisDataLoaded={setisDataLoaded}
                      allPublicSkill={allPublicSkill} allRecruitmentOrgs={allRecruitmentOrgs} allData={allData} getData={getData}
                    />
                  </>
                ) : userType === "" ? (
                  <div className="row padding_80 text-center">
                    <p className="fs-semi-bold fs-40 f-color">
                      Loading...
                    </p>
                  </div>
                ) : (
                  <UnauthorizedAccess />
                )}
              </>
            )}
          </div>
        
    </>
  );
};

export default AdminReferral;
